const appConfig = {

    // apiDomain: 'https://backendcianita.onrender.com',
    apiDomain: 'https://backend.miscelanialis.shop',
    //apiDomain: 'http://localhost:3000',
    apiPrefix: '/api',
    apiVersion: '/v1',
    authenticatedEntryPath: '/home',
    unAuthenticatedEntryPath: '/sign-in',
    tourPath: '',
    enableMock: false,
    currencySymbol: 'Q' // Guatemala Quetzales
}

export default appConfig